import { handleRequest } from "../utilities/requestHandler";

export const getRoles = () =>
    handleRequest("get", "/roles/getRoles", { _ts: Date.now() });
